import React,{Component, useState} from 'react';
import styled from 'styled-components';
import {color,bgcolor} from '../../../sass-files/variable';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import PlaceholderImage from 'src/components/Placeholder';
// import WarOfBets from '.././../../images/warofbets.jpg';
import Sicboimg from '.././../../images/sicbo.jpg';
import SpinaWin from '.././../../images/spinawin.jpg';
import { Link } from "react-router-dom";
import WheelGame from '.././../../images/wheelGamenew.jpg';
import LiveDice from '.././../../images/liveDicegameNew.jpg';
import LuckySeven from '.././../../images/lucky7new.jpg';
import LeftArrow from "../../../images/casino_slider_left.png";
import RightArrow from "../../../images/casino_slider_right.png";
import LivePoker from '../../../images/casino_live_poker.png';
import LiveJackpot from '../../../images/casino_live_jackpot.png'
import LiveAndarBahar from '../../../images/casino_live_teenpatiplus.png';
import Modal from 'src/components/Modal';
import CasinoGames from 'src/components/eu-content/casino-page/casino-slider-Games';
import config from 'src/config/config';
import cookieUtil from 'src/util/cookieUtil';
import { ECookieName } from 'src/util/utilModel';
import Intl from '../../common/Intl';
import { ifProp, theme, withProp } from 'styled-tools';

import {SRTM} from 'src/util/sportradarEvent';
import { withAppContext } from "src/store/initAppContext";
import { CRMDesktopMiniBannerClick } from 'src/util/crmUtil';

const UpDown1 = `${'static/Image/7up&down1.jpg'}`


const {secondarycolor} = color
const {loginbg} = bgcolor
const {loginbghover} = bgcolor
const {signupbghover} = bgcolor
const isAuth = cookieUtil.get(ECookieName.COOKIE_TOKEN);
function TopSection (props) {
    const AllGame = [
        {
            id: 25,
            type: 'betgames',
            game: "wheel of fortune_laptop",
            // url: 'http://google.com',
            imgsrc: UpDown1,
            platformCode: "WACS",
            code: "BGAMES-7",
        },
        { id: 45,
            type: 'TV BET',
            game: "Wheelbet",
            // url: 'http://google.com',
            imgsrc: WheelGame ,
            platformCode: "WACS",
            code: "TVBET-2",
        },
        {
            id: 17,
            type: 'betgames',
            game: "dice dual_laptop",
            // url: 'http://google.com',
            imgsrc: LiveDice,
            platformCode: "WACS",
            code: "BGAMES-10",
        },
        
       
       {
            id: 1,
            type: 'EVOLUTION',
            game: "baccarat",
            // url: 'http://google.com',
            platformCode: "WACS",
            code: "EVOLUTION-baccarat-lobby",
            imgsrc: Sicboimg
        }, 
        
  
        // {
        //     id: 59,
        //     type: 'JACKPOT',
        //     game: "JACKPOT",
        //     catagoryName: "All",
        //     // url: 'http://google.com',
        //     imgsrc: SpinaWin,
        //     platformCode: "SLottery",
        //     code: "SLottery",
        // },
        {
            id: 21,
            type: 'betgames',
            game: "Lucky 7_laptop",
            // url: 'http://google.com',
            imgsrc: SpinaWin,
            platformCode: "WACS",
            code: "BGAMES-1",
        },
        // {
        //     id: 34,
        //     type: 'EZUGI',
        //     game: "lucky-7_laptop",
        //     // url: 'http://google.com',
        //     imgsrc: SpinaWin,
        //     platformCode: "WACS",
        //     code: "EZUGI-lucky7_228001",
        // },
    
        { id: 9,
			type: 'super-spade',
			game: "andar bahar",
			catagoryName: "Andar Bahar",
			// url: 'http://google.com',
			imgsrc: LiveAndarBahar,
			platformCode: "WACS",
			code: "Ab1lkajgh7trgh20",
		},
    ]
 const [modal, setModal ]= useState(false);
 const handleClose = () => setModal(false);

 const { app: { brandId }} = props

 const toggleModal=(gameName)=>{
    setSelectedGame([gameName])
    setModal(!modal);

     //for sport Radar
     if(gameName && typeof gameName === 'object'){
        SRTM.retargetCasinoEvent(brandId, {
            id: gameName.id || '',
            name: gameName.game,
            category: gameName.type,
            image: gameName.imgsrc
          });
          
        //CRM CRMDesktopMiniBannerClick
        CRMDesktopMiniBannerClick(brandId,gameName.imgsrc)
     }  
    }
    const [selectedGame, setSelectedGame]= useState([]);


    //   AllGame.map((item, index)=>{
    //     <p>{item.game}</p>
    //     // debugger
    // }) 
   

  
        return (
            // <TopSectionWrapper>
            <TopSectionWrapper>
                <FirstColoumn>
                {/* <TopBlocks onClick={() => toggleModal(AllGame[1])}> */}
                    {/* <span className="live_text">
                        <p>Live</p>
                        <h4>Poker</h4>
                    </span> */}
                    {/* <span className="img_span_first">
                    </span>
                </TopBlocks> */}
                <Link to="/" className="colfirst">
                        {/* <img src={BlackJack} alt="Black Jack"></img> */}
                        {/* <h4>Blackjack</h4> */}
                        <Intl langKey="COLFIRST@GAME1">
                            {(message) => {
                                return (
                                    <LazyLoadImage src={`${config.imageS3Host}${message}`}  effect="none" height="100%" width="100%" visibleByDefault={false} placeholder={<PlaceholderImage/>}/>
                                );
                            }}
                        </Intl>
                        <div className="overlay">
                            <div className="buttons">
                            {/* <span className="img_span_first"> */}
                            {
                                cookieUtil.get(ECookieName.COOKIE_TOKEN) ? <PlayButton>
                                <button onClick={() =>  toggleModal(AllGame[1]) }><Intl langKey="TITLE@PLAY" /></button>
                            </PlayButton> : <DemoButton>
                                    <button onClick={() => toggleModal(AllGame[1])}><Intl langKey="TITLE@DEMO" /></button>
                                </DemoButton>
                            }
                                
                                
                            {/* </span>     */}
                            </div>
                        </div>
                    </Link>
                {/* <TopBlocks onClick={() => toggleModal(AllGame[2])}> */}
                    {/* <span className="live_text">
                        <p>Live</p>
                        <h4>Baccarat</h4>
                    </span> */}
                    {/* <span className="img_span_second">
                    </span> */}
                {/* </TopBlocks> */}
                <Link to="/" className="colsecond">
                        {/* <img src={BlackJack} alt="Black Jack"></img> */}
                        {/* <h4>Blackjack</h4> */}
                        <Intl langKey="COLFIRST@GAME2">
                            {(message) => {
                                return (
                                    <LazyLoadImage src={`${config.imageS3Host}${message}`}  effect="none" height="100%" width="100%" visibleByDefault={false} placeholder={<PlaceholderImage/>}/>
                                );
                            }}
                        </Intl>
                        <div className="overlay">
                            <div className="buttons">
                            {/* <span className="img_span_first"> */}
                            {
                                cookieUtil.get(ECookieName.COOKIE_TOKEN) ? <PlayButton>
                                <button onClick={() =>  toggleModal(AllGame[2]) }><Intl langKey="TITLE@PLAY" /></button>
                            </PlayButton> : <DemoButton>
                                    <button onClick={() => toggleModal(AllGame[2])}><Intl langKey="TITLE@DEMO" /></button>
                                </DemoButton>
                            }
                                
                                
                            {/* </span>     */}
                            </div>
                        </div>
                    </Link>
                {/* <TopBlocks onClick={() => toggleModal(AllGame[0])}> */}
                    {/* <span className="live_text">
                        <p>Live</p>
                        <h4>Spin a Win</h4>
                    </span> */}
                    {/* <span className="img_span_thired">
                    </span>
                </TopBlocks> */}
                <Link to="/" className="colthird">
                        {/* <img src={BlackJack} alt="Black Jack"></img> */}
                        {/* <h4>Blackjack</h4> */}
                        <Intl langKey="COLFIRST@GAME3">
                            {(message) => {
                                return (
                                    <LazyLoadImage src={`${config.imageS3Host}${message}`}  effect="none" height="100%" width="100%" visibleByDefault={false} placeholder={<PlaceholderImage/>}/>
                                );
                            }}
                        </Intl>
                        <div className="overlay">
                            <div className="buttons">
                            {/* <span className="img_span_first"> */}
                            {
                                cookieUtil.get(ECookieName.COOKIE_TOKEN) ? <PlayButton>
                                <button onClick={() =>  toggleModal(AllGame[4]) }><Intl langKey="TITLE@PLAY" /></button>
                                </PlayButton> : <DemoButton>
                                    <button onClick={() => toggleModal(AllGame[4])}><Intl langKey="TITLE@DEMO" /></button>
                                </DemoButton>
                            }
                                
                                
                            {/* </span>     */}
                            </div>
                        </div>
                    </Link>
                <Modal show={modal} handleClose={handleClose}>
                <CasinoGames modalState={modal} data={selectedGame} open={'true'}/>   
                </Modal>
            </FirstColoumn>
            </TopSectionWrapper>
        )
    
}

export default withAppContext(TopSection)

// const TopSectionWrapper = styled.div`
//     display: flex;
//     align-items: center;
//     flex-direction: row;
//     width: 100%;
// `;

// const TopBlocks = styled.div`
//     width: 33.3333%;
//     display: flex;
//     align-items: center;
//     flex-direction: row;
//     border: 1px solid #333;
//     background-color: #041629;
//     cursor: pointer;

//     span {
//         width: 100%;
//         display: flex;
//         align-items: center;

//         img {
//             width: 100%;
//         }
//     }

//     .img_span_first  {
//         height: 150px;
//         background-image: url(${config.imageS3Host}${WheelGame});
//         background-size: cover;
//         background-repeat: no-repeat;
//         background-position: center;
//     }

//     .img_span_second  {
//         height: 150px;
//         background-image: url(${config.imageS3Host}${LiveDice});
//         background-size: cover;
//         background-repeat: no-repeat;
//         background-position: center;
//     }

//     .img_span_thired  {
//         height: 150px;
//         background-image: url(${config.imageS3Host}${LuckySeven});
//         background-size: cover;
//         background-repeat: no-repeat;
//         background-position: center;
//     }

//     .live_text {
//         display: flex;
//         flex-direction: column;
//         align-items: flex-start;
//         justify-content: center;
//         padding-left: 30px;
//         text-transform: uppercase;

//         p {
//             margin: 0;
//             margin-bottom: 3px;
//             color: #33abaf;
//             font-size: 22px;
//             font-family: 'poppinslight';
//         }

//         h4 {
//             margin: 0;
//             font-size: 25px;
//             color: ${secondarycolor};
            
//         }
//     }
// `;

const PlayButton = styled.div`
    transform: skew(340deg);
    /* border: 1px solid #CB9640; */
    border: ${theme('palette.DemoButtonBorder')};
    margin-left: 10px;
    /* background:linear-gradient(180deg, #000000 0%, #2F3236 100%);  */
    background: ${theme('palette.DemoButtonBg')};
    box-shadow: 3px 5px 4px rgba(0, 0, 0, 0.25);
    transition: color 0.1s linear 0s;
    

    :hover {
        background: ${theme('palette.primary-background-color-linear-new')};
        transition: color 0.1s linear 0s;
    }
    button {
        width: 80px;
        text-align: center;
        display: block;
        text-decoration: none;
        padding: 10px 0px;
        font-size: 14px;
        transform: skew(-340deg);
        /* color: ${secondarycolor}; */
        color: ${theme('palette.DemoButtonColor')};
        text-transform: uppercase;
        background-color: transparent;
        border: none;
        cursor: pointer;
    }
`;

const DemoButton = styled.div`
     transform: skew(340deg);
    /* border: 1px solid #CB9640; */
    border: ${theme('palette.DemoButtonBorder')};
    margin-left: 10px;
    /* background:linear-gradient(180deg, #000000 0%, #2F3236 100%);  */
    background: ${theme('palette.DemoButtonBg')};
    box-shadow: 3px 5px 4px rgba(0, 0, 0, 0.25);
    transition: color 0.1s linear 0s;
    

    :hover {
        background: ${theme('palette.primary-background-color-linear-new')};
        transition: color 0.1s linear 0s;
    }

    button {
        width: 80px;
        text-align: center;
        display: block;
        text-decoration: none;
        padding: 10px 0px;
        font-size: 14px;
        transform: skew(-340deg);
        /* color: ${secondarycolor}; */
        color: ${theme('palette.DemoButtonColor')};
        text-transform: uppercase;
        background-color: transparent;
        border: none;
        cursor: pointer;
    }
`;

const FirstColoumn = styled.div`
    width: 100%;
    /* height: 190px; */
    height: auto;
    display: flex;
    align-items: center;
    flex-direction: row;
    gap: 5px;

    a {
        /* width: 100%; */
        flex: 0 0 33.1%;
        height: 100%;
        display: flex;
        align-items: center;
        flex-direction: row;
        background-size: cover;
        background-repeat: no-repeat;
        position: relative;
        border: 1px solid #333;
        /* margin: 5px 5px 0px 0px; */
        margin: 0px;
        position: relative;
        cursor: default;

        img {
            display: flex;
            max-width: 100%;
            width: 100%;
            height: 100%;
        }
    }

    a:hover .overlay {
        -webkit-transform: scale(1);
        -ms-transform: scale(1);
        transform: scale(1);
        opacity: 0.9;
    }

    .colfirst {
        // height: 150px;
        /* background-image: url(${config.imageS3Host}${WheelGame}); */
        align-items: flex-end;

        h4 {
            bottom: 30px;
        }
    }

    .colsecond {
        // height: 150px;
        /* background-image: url(${config.imageS3Host}${LiveDice}); */
        align-items: flex-end;

        h4 {
            bottom: 30px;
        }
    }

    .colthird {
        // height: 150px;
        /* background-image: url(${config.imageS3Host}${LuckySeven}); */
        align-items: flex-end;

        h4 {
            bottom: 30px;
        }
    }

`;

const TopSectionWrapper = styled.div`
    width: 100%;
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    flex-direction: row;

    .overlay {
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        opacity: 0.9;
        background: ${theme('palette.overlayBGColor')};
        overflow: hidden;
        width: 100%;
        height: 100%;
        -webkit-transform: scale(0);
        -ms-transform: scale(0);
        transform: scale(0);
        -webkit-transition: .5s ease;
        transition: .5s ease;
      }
      
      .buttons {
        color: #fff;
        font-size: 20px;
        position: absolute;
        top: 50%;
        left: 50%;
        -webkit-transform: translate(-50%, -50%);
        -ms-transform: translate(-50%, -50%);
        transform: translate(-50%, -50%);
        text-align: center;
        display: flex;
        align-items: center;
        justify-content: center;
      }
`;

